import * as React from "react";

/**
 * When true, tells Popout components to render inline instead of portaling
 * to document.body. Provided by overlay containers (Modal V2, Drawer) to
 * prevent pointer-events and aria-hidden conflicts with Radix Dialog.
 */
export const DisablePortalToBodyContext = React.createContext<boolean>(false);
